/* My Essenza — secções da home (s-home-seccoes 02/10/2026): setas dos carrosséis, separadores, contador real. */
(function () {
  if (window.__mehs) return; window.__mehs = 1;
  function setas(s) {
    var fila = s.querySelector("[data-mehs-fila]"); if (!fila) return;
    Array.prototype.forEach.call(s.querySelectorAll("[data-mehs-seta]"), function (b) {
      b.addEventListener("click", function () {
        var c = fila.firstElementChild, passo = c ? c.getBoundingClientRect().width + 16 : 300;
        fila.scrollBy({ left: passo * parseInt(b.getAttribute("data-mehs-seta"), 10), behavior: "smooth" });
      });
    });
  }
  function tabs(s) {
    var bs = s.querySelectorAll('[role="tab"]'), mais = s.querySelector("[data-mehs-mais]");
    Array.prototype.forEach.call(bs, function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(bs, function (o) {
          var on = o === b; o.setAttribute("aria-selected", on ? "true" : "false");
          var p = document.getElementById(o.getAttribute("aria-controls")); if (p) p.hidden = !on;
        });
        if (mais) mais.href = b.getAttribute("data-href");
      });
    });
  }
  function contador(el) {
    var fim = Date.parse(el.getAttribute("data-fim")), d = el.getAttribute("data-d") || "d", t = el.querySelector(".mehs-cd__t");
    if (!fim) return;
    function z(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var s = Math.floor((fim - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; return; }
      var dd = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
      t.textContent = (dd > 0 ? dd + d + " " : "") + z(h) + " : " + z(m) + " : " + z(ss);
      el.hidden = false; setTimeout(tick, 1000);
    }
    tick();
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-mehs-car]"), setas);
    Array.prototype.forEach.call(document.querySelectorAll("[data-mehs-tabs]"), tabs);
    Array.prototype.forEach.call(document.querySelectorAll(".mehs-cd[data-fim]"), contador);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
